import { Info } from '@phosphor-icons/react';
import { InputComponent } from '../../../../../components/InputComponent';
import { Brokerages } from '../../components/Brokerages/intex';
import { transformMaskCurrency } from '../../../../../utils/transformMaskCurrency';
import {
  AllActiveContainer,
  ContentItemsFilterColumnTable,
  ContentTable,
  FooterTable,
} from './styles';
import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { AllTable } from './components/AllTable';
import { baseURL } from '../../../../../utils/baseURL';
import { financeRoutes } from '../../../../../utils/RoutesApi';
import {
  BoxPctMap,
  EMPTY_BOX_PCT_MAP,
  applyBoxAllocation,
  buildBoxPctMap,
  isVisibleAfterBox,
} from './boxAllocation';
import { ModalDesigner } from '../../../../../components/ModalDesigner';
import { useActivesWallet } from '../../hooks/ActivesHooks';
import { FormCreateRule } from '../../../../components/Boltz/MyWallet/FormCreateRule';
import { IPropsException } from '../../../../components/RenderConditionalObjective';
import { useActives } from '../../../../../hooks/useActives';
import { EditColumnsButton } from '../../../../../components/EditColumnsButton';

interface IPropsEditRule {
  Exception: IPropsException[];
  ValorExp: number;
  aportarQtde: number;
  closingPrice: number;
  corporationName: string;
  equitiesQuantity: number;
  novoupdateValue: number;
  percent: number;
  tickerSymbol: string;
  updateValue: number;
  edit?: boolean;
  typeEdit: 'action' | 'fii' | 'all' | 'broker' | 'stock' | 'reit' | 'etf';
  brokerEdit?: string;
}

export function AllActive() {
  const {
    fullWallet,
    setFullWallet,
    selectedBrokerage,
    updateWallet,
  } = useActivesWallet();
  // @ts-ignore
  const { showActive } = useActives();
  let filterTable = localStorage.getItem('filterTableAll-v1.0.0');
  // @ts-ignore
  filterTable = JSON.parse(filterTable);
  const [rule, setRule] = useState<IPropsEditRule>({} as IPropsEditRule);
  const [showModalSelectedDateTable, setShowModalSelectedDateTable] =
    useState(false);
  const [filterTextSearchActive, setFilterTextSearchActive] = useState('');
  const [boxPct, setBoxPct] = useState<BoxPctMap>(EMPTY_BOX_PCT_MAP);
  const [showModalCreateRule, setShowModalCreateRule] = useState(false);
  const [showMaintenanceModal, setShowMaintenanceModal] = useState(() => {
    return localStorage.getItem('maintenance_wallet_modal') !== 'close';
  });
  const [filterShowColumnTable, setFilterShowColumnTable] = useState(() => {
    if (filterTable === null) {
      return ['Ativo', 'Tipo', 'Nota', 'Quant.', 'Objetivo'];
    } else {
      return filterTable;
    }
  });
  const arrColumnTableData = [
    'Ativo',
    'Tipo',
    'Nota',
    'Cotação',
    'Quant.',
    'Patrimônio',
    'Atual',
    'Diferença',
    'Preço médio',
    'Preço médio com proventos',
    'Total de proventos recebidos',
    'Total investido',
    'Rentabilidade com proventos',
    'Lucro/Prejuízo',
  ];

  const arrColumnTableRecommended = [
    'Ativo',
    'Tipo',
    'Nota',
    'Quant.',
    'Objetivo',
  ];

  useEffect(() => {
    localStorage.setItem(
      'filterTableAll-v1.0.0',
      JSON.stringify(filterShowColumnTable)
    );
  }, [filterShowColumnTable]);

  // Busca os boxes (objetivos/reservas) para descontar da listagem os ativos
  // de renda fixa já alocados. Usa box_applied_percentage (estável) em vez do
  // valor em R$ armazenado.
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(
          `${baseURL}${financeRoutes.FINANCE_BOX_LIST}`
        );
        if (active) setBoxPct(buildBoxPctMap(res.data || []));
      } catch (error) {
        // Sem boxes ou falha de rede: lista segue sem ajuste.
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  function handleSelectedColumnTable(value: any) {
    // @ts-ignore
    const isValueAllReadyExist = filterShowColumnTable.find(
      (item: any) => item === value
    );
    if (isValueAllReadyExist) {
      setFilterShowColumnTable((state: any) => {
        return state.filter((item: any) => item !== value);
      });
    } else {
      setFilterShowColumnTable((state: any) => {
        return [...state, value];
      });
    }
  }

  // Ativos visíveis após desconto de boxes (via box_applied_percentage):
  //  - 100% alocado (== 1) sai: não conta nem soma no total;
  //  - parcial (< 1) entra apenas com a diferença (valor livre = bruto × (1 − pct)),
  //    já refletida no updateValue ajustado por applyBoxAllocation.
  const visiblePositions = useMemo(
    () =>
      (fullWallet?.positionsAll ?? [])
        .map((item: any) => applyBoxAllocation(item, boxPct))
        .filter(isVisibleAfterBox),
    [fullWallet, boxPct]
  );

  const amountActives = visiblePositions.length;

  // Total considerando só o valor livre (fora de boxes) dos ativos visíveis.
  const totalInvestmentsOutOfBox = useMemo(
    () =>
      new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(
        visiblePositions.reduce(
          (acc: number, item: any) => acc + Number(item.updateValue || 0),
          0
        )
      ),
    [visiblePositions]
  );

  // const totalProventosPorTicker = fullWallet?.positionsAll?.reduce(
  //   (acc, item) => {
  //     const ticker = item.tickerSymbol

  //     if (!ticker) return acc

  //     acc[ticker] = (acc[ticker] ?? 0) + (item.total_proventos ?? 0)
  //     return acc
  //   },
  //   {} as Record<string, number>
  // ) ?? {}

  // const isTotalAmountReceivedInThePeriod = transformMaskCurrency(
  //   Object.values(totalProventosPorTicker).reduce(
  //     (acc, v) => acc + v,
  //     0
  //   )
  // )
  // console.log('MAPA:', totalProventosPorTicker)




  return (
    <AllActiveContainer>
      {window.screen.width > 768 && <Brokerages />}
      {/* <InputComponent
        isSearch
        placeholder="Busque por código ou nome da empresa"
        roundedFull
        onChange={(e) => setFilterTextSearchActive(e.target.value)}
      /> */}
      <ContentTable>
        <div id="cart-ativos">
          <header>
            {/*<span*/}
            {/*  style={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}*/}
            {/*>*/}
            {/*  Objetivo recomendado*/}
            <span>Meus ativos</span>
            <EditColumnsButton
              label="Adicionar campos"
              onClick={() => setShowModalSelectedDateTable(true)}
            />
          </header>
          <AllTable
            filterShowColumnTable={filterShowColumnTable as string[]}
            fullWallet={fullWallet}
            handleOrientationTable={setFullWallet}
            setRule={setRule}
            selectedBrokerage={selectedBrokerage}
            setShowModalCreateRule={setShowModalCreateRule}
            filterTextSearchActive={filterTextSearchActive}
            boxPct={boxPct}
          />
        </div>
        <FooterTable>
          <p>
            Total:{' '}
            <strong>
              {showActive ? totalInvestmentsOutOfBox : 'R$ ******'}
            </strong>{' '}
          </p>
          <p>
            Total de ativos: <strong>{amountActives}</strong>
          </p>
          <p>
            Porcentagem total: <strong>100%</strong>
          </p>
        </FooterTable>
      </ContentTable>

      <ModalDesigner
        id="selecionarColunas"
        isOpen={showModalSelectedDateTable}
        setState={setShowModalSelectedDateTable}
        title="Adicionar campos"
        size="sm"
      >
        <ContentItemsFilterColumnTable>
          <span className="recommendText"> Recomendado</span>
          <div className="contentInput">
            {arrColumnTableRecommended.map((item) => (
              <label key={item}>
                <input
                  type="checkbox"
                  value={item}
                  defaultChecked={filterShowColumnTable.includes(item)}
                  onChange={(e) => handleSelectedColumnTable(e.target.value)}
                />
                {item}
              </label>
            ))}
          </div>

          <span className="addMore">CAMPOS ADICIONAIS</span>
          <div className="contentInput">
            {arrColumnTableData
              .filter(
                (item) =>
                  item !== 'Ativo' &&
                  item !== 'Tipo' &&
                  item !== 'Nota' &&
                  item !== 'Quant.'
              )
              .map((item) => (
                <label key={item}>
                  <input
                    type="checkbox"
                    value={item}
                    defaultChecked={filterShowColumnTable.includes(item)}
                    onChange={(e) => handleSelectedColumnTable(e.target.value)}
                  />
                  {item}
                </label>
              ))}
          </div>
          <span className="important">
            <Info size={16} color="#505050" weight="bold" /> IMPORTANTE
          </span>
          <p className="warning">
            Alterar a estrutura da tabela de ativos padrão pode afetar sua
            experiência, recomendamos que sempre que possível, utilize a tabela
            padrão.
          </p>
        </ContentItemsFilterColumnTable>
      </ModalDesigner>
      {showModalCreateRule && (
        <FormCreateRule
          rule={rule}
          setShowModalCreateRule={setShowModalCreateRule}
          showModalCreateRule={showModalCreateRule}
          update={updateWallet}
        />
      )}
      {/* <ModalDesigner
        id="maintenanceWallet"
        isOpen={showMaintenanceModal}
        setState={(value: boolean) => {
          if (!value) {
            localStorage.setItem('maintenance_wallet_modal', 'close');
          }
          setShowMaintenanceModal(value);
        }}
        title="🚧 Estamos evoluindo para você!"
        size="md"
      >
        <div
          style={{
            textAlign: 'center',
            padding: '1rem',
            lineHeight: '1.7',
          }}
        >
          <p>
            O Simulador de Aportes, Estratégias e a Carteira do iBox6 estão
            temporariamente em manutenção para receber melhorias e proporcionar uma
            experiência ainda melhor. ✨
          </p>

          <h3
            style={{
              margin: '1.5rem 0',
              color: '#2563eb',
            }}
          >
            🚀 E tem uma grande novidade chegando em breve!
          </h3>

          <p>
            Agradecemos sua compreensão e, em breve, tudo estará disponível novamente.
            💙
          </p>
        </div>
      </ModalDesigner> */}
    </AllActiveContainer>
  );
}
